// extracted by mini-css-extract-plugin
export default {"popular-products-heading":"popular-products-heading--dgSqf","products":"products--BBTiZ","products__product-wrapper":"products__product-wrapper--egsNc"};